import { takeEvery, call, put } from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import {
	getNetSalesSuccess,
	getNetSalesFailure,
	getUnitSuccess,
	getUnitFailure,
	getChannelBreakdownSalesSuccess,
	getChannelBreakdownUnitsSuccess,
	getChannelBreakdownSalesFailure,
	getUpcValidationSuccess,
	getUpcValidationFailure,
	getDataRefreshTimestampSuccess,
	getDataRefreshTimestampFailure,
} from '../actions/salesActions';
import APIENDPOINTS from '../../constants/apiconstants';
import { saveData } from '../service/saveDataService';
import { getData } from '../service/getDataService';

export const parseSummaryKeys = (keys) => {
	return {
		netsalesTotal: keys.netSalesTotal,
		gmvTotal: keys.gmvTotal,
		salesVolumeTotal: keys.unitsTotal,
	};
};

export const parseCB = (response, kpi) => {
	const salesCB = {
		data: response.data[0]?.channelData,
		kpi: response.data[0]?.kpi,
		summary: parseSummaryKeys(response.tabData),
	};

	const unitsCB = {
		data: response.data[1]?.channelData,
		kpi: response.data[1]?.kpi,
		summary: parseSummaryKeys(response.tabData),
	};

	const gmvCB = {
		data: response.data[2]?.channelData,
		kpi: response.data[2]?.kpi,
		summary: parseSummaryKeys(response.tabData),
	};

	if (kpi === 'sales') {
		return salesCB;
	} else if (kpi === 'units') {
		return unitsCB;
	} else {
		return gmvCB;
	}
};

export function* getDataRefreshTimestampSaga(action) {
	const { portalUserContext } = action.payload;
	try {
		const response = yield call(
			getData,
			APIENDPOINTS.DATA_REFRESH,
			portalUserContext.result
		);
		if (response?.statusCode > 200) {
			yield put(getDataRefreshTimestampFailure(response.statusCode));
		} else {
			yield put(getDataRefreshTimestampSuccess(response.json));
		}
	} catch (error) {
		yield put(getDataRefreshTimestampFailure(500));
	}
}

export function* getNetSalesSaga(action) {
	const { portalUserContext, request } = action.payload;

	try {
		const netSaleData = yield call(
			saveData,
			request,
			`${APIENDPOINTS.TREND_URL}/v2/trend-data`,
			portalUserContext.result
		);

		if (netSaleData?.statusCode > 200) {
			yield put(getNetSalesFailure(netSaleData?.statusCode));
		} else {
			yield put(
				getNetSalesSuccess({
					netSaleData: netSaleData?.json?.data,
				})
			);
		}
	} catch (error) {
		yield put(getNetSalesFailure(500));
	}
}

export function* getUnitSaga(action) {
	const { portalUserContext, request } = action.payload;

	try {
		const unitData = yield call(
			saveData,
			request,
			`${APIENDPOINTS.TREND_URL}/v2/trend-data`,
			portalUserContext.result
		);

		if (unitData?.statusCode > 200) {
			yield put(getUnitFailure(unitData?.statusCode));
		} else {
			yield put(
				getUnitSuccess({
					unitData: unitData?.json?.data,
				})
			);
		}
	} catch (error) {
		yield put(getUnitFailure(500));
	}
}

export function* getCBSalesSaga(action) {
	const { portalUserContext, request } = action.payload;

	try {
		const channelBreakdownData = yield call(
			saveData,
			request,
			`${APIENDPOINTS.BREAKDOWN_URL}/v2/breakdown/by-channel`,
			portalUserContext.result
		);

		if (channelBreakdownData?.statusCode > 200) {
			yield put(
				getChannelBreakdownSalesFailure(channelBreakdownData?.statusCode)
			);
		} else {
			yield put(
				getChannelBreakdownSalesSuccess(
					parseCB(channelBreakdownData?.json, 'sales')
				)
			);
			yield put(
				getChannelBreakdownUnitsSuccess(
					parseCB(channelBreakdownData?.json, 'units')
				)
			);
		}
	} catch (error) {
		yield put(getChannelBreakdownSalesFailure(520));
	}
}

export function* getUPCValidationResults(action) {
	const { reqBody, portalUserContext } = action.payload;

	try {
		const response = yield call(
			saveData,
			reqBody,
			`${APIENDPOINTS.SUMMARY_URL}/V2/validate`,
			portalUserContext.result
		);

		if (response?.statusCode >= 400) {
			throw new Error(response?.statusCode);
		}

		yield put(
			getUpcValidationSuccess({
				upcs: response?.json?.result,
			})
		);
	} catch (error) {
		yield put(getUpcValidationFailure({ errorCode: error }));
	}
}

export function* salesSagaWatcher() {
	yield takeEvery(actionTypes.GET_NET_SALES, getNetSalesSaga);
	yield takeEvery(actionTypes.GET_UNIT, getUnitSaga);
	yield takeEvery(actionTypes.GET_CHANNEL_BREAKDOWN_SALES, getCBSalesSaga);
	yield takeEvery(actionTypes.GET_UPC_VALIDATION, getUPCValidationResults);
	yield takeEvery(
		actionTypes.GET_DATA_REFRESH_TIMESTAMPS,
		getDataRefreshTimestampSaga
	);
}
